import { GridColumnVisibilityModel, GridColumns, GridRenderCellParams } from "@mui/x-data-grid";
import { IAirSeaQuote } from "app/types/dataInterfaces";
import { processDate } from "app/util/dateUtils";

export const airSeaQuoteVisibilityKey = 'AIRSEA_QUOTE_GRID_VISIBILITY';

export const airSeaQuoteVisibilityModel: GridColumnVisibilityModel =  {
    shipmentRef: true,
    validToDate: true,
    shipper: true,
    consignee: true,
    originPort: false,
    destinationPort: false,
    termType: true,
    cargoMode: false,
    totalCost: true,
    associatedShipmentRef: false
}

export const airSeaQuoteColumns: GridColumns<IAirSeaQuote> = [
{
    field: 'shipmentRef',
    headerName: 'Europa Reference',
    minWidth: 150,
    flex: 1
},
{
    field: 'validToDate',
    headerName: 'Valid To',
    minWidth: 100,
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
        return processDate(params.row.validToDate);
    }
},
{
    field: 'shipper',
    headerName: 'Shipper',
    minWidth: 200,
    flex: 1,
},
{
    field: 'consignee',
    headerName: 'Consignee',
    minWidth: 200,
    flex: 1,
},
{
    field: 'originPort',
    headerName: 'Origin Port',
    minWidth: 100,
    flex: 1,
},
{
    field: 'destinationPort',
    headerName: 'Destination Port',
    minWidth: 120,
    flex: 1,
},
{
    field: 'termTypeCode',
    headerName: 'Term Type',
    minWidth: 100,
    flex: 1,
},
{
    field: 'cargoMode',
    headerName: 'Cargo Mode',
    minWidth: 100,
    flex: 1,
},
{
    field: 'totalCost',
    headerName: 'Total Cost £ *',
    minWidth: 100,
    flex: 1,
    renderCell: (params: GridRenderCellParams) => {
        const totalCost = params.row.totalCost ?? 0;
        return totalCost.toFixed(2);
    }
},
{
    field: 'associatedShipmentRef',
    headerName: 'Associated Shipment Ref',
    minWidth: 100,
    flex: 1,
}];